module.exports = __webpack_public_path__ + "img/gc-240x240.e4f7353c.png";